import { IonInput } from "@ionic/react";
import { useEffect, useRef, useState } from "react";

export default function PINInput({ length = 4, onComplete, onChange, error, idPrefix = "pin-input", className }: any) {
  const [values, setValues] = useState(Array(length).fill(""));
  const refs = useRef<(HTMLIonInputElement | null)[]>([]);

  // Foca no primeiro campo ao montar
  useEffect(() => {
    setTimeout(() => {
      refs.current[0]?.setFocus();
    }, 150);
  }, []);

  // Limpa os campos quando há erro
  useEffect(() => {
    if (error) {
      setValues(Array(length).fill(""));
      setTimeout(() => {
        refs.current[0]?.setFocus();
      }, 150);
    }
  }, [error, length]);

  const handleInput = (value: string, index: number) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newValues = [...values];
    newValues[index] = value;
    setValues(newValues);

    // 👉 Atualiza o estado a cada mudança
    onChange?.(newValues.join(""));

    // 👉 Move para o próximo campo
    if (value !== "" && index < length - 1) {
      setTimeout(() => {
        refs.current[index + 1]?.setFocus();
      }, 10);
    }

    // 👉 Se preencheu todos, retorna
    if (newValues.every((v) => v !== "")) {
      onComplete?.(newValues.join(""));
    }
  };

  const handleKeyDown = (ev: any, index: number) => {
    // 👉 Se apertou backspace num campo vazio, volta 1
    if (ev.key === "Backspace" && values[index] === "" && index > 0) {
      const newValues = [...values];
      newValues[index - 1] = "";
      setValues(newValues);
      onChange?.(newValues.join(""));
      setTimeout(() => {
        refs.current[index - 1]?.setFocus();
      }, 10);
    } else if (ev.key === "Backspace" && values[index] !== "") {
      // Se apagou um dígito, atualiza o estado
      const newValues = [...values];
      newValues[index] = "";
      setValues(newValues);
      onChange?.(newValues.join(""));
    }
  };

  return (
    <div className={className} style={{ display: "flex", gap: "var(--pin-gap, 15px)", justifyContent: "center", alignItems: "center", width: "100%", margin: "0 auto" }}>
      {values.map((digit, i) => (
        <IonInput
          key={i}
          id={`${idPrefix}-${i}`}
          aria-label={`Dígito ${i + 1} do PIN`}
          aria-invalid={!!error}
          ref={(el) => (refs.current[i] = el)}
          type="text"
          inputmode="numeric"
          maxlength={1}
          value={digit}
          onIonInput={(e: any) => handleInput(e.target.value, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          style={{
            '--background': error ? '#ffe5e5' : '#fff',
            '--padding-start': '0',
            '--padding-end': '0',
            maxWidth: 'var(--pin-width, 50px)',
            // height: '40px',
            // fontSize: '14px',
            // fontWeight: 'bold',
            textAlign: 'center',
            borderRadius: 'var(--pin-radius, 8px)',
            margin: '0',
            border: error ? '1px solid var(--ion-color-danger)' : '1px solid var(--pin-border-color, #000)',
          }}
        />
      ))}
    </div>
  );
}
